import React, { useEffect, useState, useRef, useCallback } from 'react';
import { logo } from '../component/ImageList';
import { Link, useNavigate } from 'react-router-dom';
import baseURL from '../component/baseURL';
import { ReactNotifications, Store } from 'react-notifications-component';
import showNotification from '../component/Notification';
import 'animate.css';
import { defaultProfileAvatar } from '../component/ImageList';
import Cropper from 'react-easy-crop';
import { initLoginAnimation } from '../utils/loginAnimation';
import { getCroppedImg } from '../utils/cropImage';
import { SignUpCard } from '../components/ui/sign-up-card';

export default function Signup({ transferProps }) {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [phone, setPhone] = useState('');
    const [isCropperOpen, setIsCropperOpen] = useState(false);
    const [cropperImageSrc, setCropperImageSrc] = useState('');
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
    const [isCodePopupOpen, setIsCodePopupOpen] = useState(false);
    const [agentKey, setAgentCode] = useState(['', '', '', '', '', '']);
    const codeInputRefs = useRef([]);
    const [countryNameArray, setCountryNameArray] = useState([]);
    const [countryCode, setCountryCode] = useState('');
    const [countryName, setCountryName] = useState('');
    const [stateNameArray, setStateNameArray] = useState([]);
    const [stateCode, setStateCode] = useState('');
    const [stateName, setStateName] = useState('');
    const [cityNameArray, setCityNameArray] = useState([]);
    const [cityCode, setCityCode] = useState('');
    const [cityName, setCityName] = useState('');
    const [profileImageSrc, setProfileImageSrc] = useState(null);
    const [profileImage, setProfileImage] = useState(null);
    const [isUploadingImage, setIsUploadingImage] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const profileImageInputRef = useRef(null);
    const canvasContainerRef = useRef(null);
    const animationRef = useRef(null);
    const sceneRef = useRef(null);

    useEffect(() => {
        const userID = localStorage.getItem('userID');
        const agentKey = localStorage.getItem('agentKey');

        // If both userID and agentKey exist, navigate to home page

        fetchCountryAPI();
    }, []);

    useEffect(() => {
        document.body.classList.add('signup-page');
        return () => {
            document.body.classList.remove('signup-page');
        };
    }, []);

    useEffect(() => {
        const cleanup = initLoginAnimation(canvasContainerRef, animationRef, sceneRef);
        return cleanup;
    }, []);



    function signupApi() {
        if (isSubmitting) return;

        // const { navigate } = this.props.navigation;
        if (phone != '' && firstName != '' && lastName != '' && email != '' && password != '' && confirmPassword != '') {
            setIsSubmitting(true);
            //   this.setState({ editMode: false })
            let formdata = new FormData();
            formdata.append("key", '81dc9bdb52d04dc20036dbd8313ed055')
            formdata.append("fname", firstName)
            formdata.append("lname", lastName)
            formdata.append("email", email)
            formdata.append("password", password)
            formdata.append("phone", phone)
            formdata.append("state", stateCode)
            formdata.append("city", cityCode)
            formdata.append("country", countryCode)
            formdata.append("state_name", stateName)
            formdata.append("city_name", cityName)
            formdata.append("country_name", countryName)
            fetch(baseURL.URL + '/users/signup', {
                method: 'POST',
                body: formdata
            }).then((response) => response.json())
                .then((responseJson) => {
                    const result = responseJson
                    console.log('result')
                    console.log(result)
                    if (responseJson.server.code === 200) {
                        // this.setState({ jsonResult: responseJson.response })
                        // this.setLang(this.state.selectedLangShort)
                        showNotification('Success', 'Account created successfully', 'success');

                        // Get user_id from response if available
                        const newUserID = responseJson.response?.user_id;

                        // If image was uploaded, upload it to server
                        if ((profileImage || profileImageSrc) && newUserID) {
                            // Store userID temporarily for image upload
                            localStorage.setItem('userID', newUserID);
                            // Upload the image
                            const imageToUpload = profileImage || profileImageSrc;
                            updateProfileImage(imageToUpload, newUserID);
                        }

                        setTimeout(() => {
                            navigate('/');
                        }, 1000);

                    }
                    else {
                        showNotification('Error', responseJson.server.message || 'Unable to create account', 'danger');
                    }
                })
                .catch((error) => {
                    console.error(error);
                    showNotification('Error', 'Something went wrong while creating account', 'danger');
                })
                .finally(() => {
                    setIsSubmitting(false);
                });
        } else {
            showNotification('Error', 'All fields are mandatory', 'danger');
            setIsSubmitting(false);
        }
    }

    function handleCountryChange(e) {
        const selectedCode = e.target.value;
        setCountryCode(selectedCode);

        const selectedCountry = countryNameArray.find((country) => country.code === selectedCode);

        if (selectedCountry) {
            setCountryName(selectedCountry.name);
            handleInputChange('country', selectedCountry.name);
        }

        setStateNameArray([]);
        setCityNameArray([]);
        setStateCode('');
        setStateName('');
        setCityCode('');
        setCityName('');

        setTimeout(() => {
            fetchStateAPI(selectedCode);
        }, 100);
    }

    function handleStateChange(e) {
        const selectedCode = e.target.value;
        setStateCode(selectedCode);

        const selectedState = stateNameArray.find((states) => states.region_code === selectedCode);

        if (selectedState) {
            setStateName(selectedState.region_name);
            handleInputChange('state', selectedState.region_name);
        }

        setCityNameArray([]);
        setCityCode('');
        setCityName('');

        setTimeout(() => {
            fetchCityAPI(selectedCode);
        }, 100);
    }

    function handleCityChange(e) {
        const selectedCode = e.target.value;
        setCityCode(selectedCode);

        const selectedCity = cityNameArray.find((citys) => citys.city_id === selectedCode);

        if (selectedCity) {
            setCityName(selectedCity.city_name);
            handleInputChange('city', selectedCity.city_name);
        }
    }


    const updateProfileImage = (profileImageBase64, userIDParam = null) => {
        const userID = userIDParam || localStorage.getItem('userID');

        if (!userID) {
            showNotification('Error', 'Session expired. Please login again.', 'danger');
            navigate('/');
            return;
        }

        setIsUploadingImage(true);
        const formdata = new FormData();
        formdata.append('user_id', userID);
        formdata.append('key', '81dc9bdb52d04dc20036dbd8313ed055');
        // Send full data URL format: data:image/jpeg;base64,<base64string>
        formdata.append('profile_image', profileImageBase64);

        fetch(baseURL.URL + '/users/change_profile_pic', {
            method: 'POST',
            body: formdata
        })
            .then((response) => response.json())
            .then((responseJson) => {
                console.log('Image upload response:', responseJson);

                // Check multiple possible response structures
                const serverCode = responseJson.server?.code || responseJson.code;
                const resultCode = responseJson.server?.result_code || responseJson.result_code;
                const apiResponse = responseJson.response || responseJson.server?.response || responseJson;

                // Check if upload was successful (code 200 or result_code 200)
                if (serverCode === 200 || resultCode === 200) {
                    const apiImage = apiResponse?.profile_image || apiResponse?.picture || apiResponse?.image;

                    if (apiImage) {
                        // Add timestamp to prevent caching
                        const imageWithTimestamp = apiImage + (apiImage.includes('?') ? '&' : '?') + 't=' + Date.now();
                        // Save to localStorage for Profile page
                        localStorage.setItem('profileImage', apiImage);
                        // Also save to consumerProfileImage for Header component
                        localStorage.setItem('consumerProfileImage', apiImage);
                        setProfileImageSrc(imageWithTimestamp);
                        setProfileImage(imageWithTimestamp);
                        // Dispatch event to update Header component

                        showNotification('Success', 'Image upload successful', 'success');
                    } else {
                        console.warn('Image URL not found in response:', apiResponse);
                        showNotification('Error', 'Image uploaded but URL not received', 'danger');
                    }
                } else {
                    const errorMessage = responseJson.server?.message || responseJson.message || 'Unable to update profile image';
                    console.error('Upload failed:', responseJson);
                    showNotification('Error', errorMessage, 'danger');
                }
            })
            .catch((error) => {
                console.error('Image upload error:', error);
                showNotification('Error', 'Something went wrong while uploading image', 'danger');
            })
            .finally(() => setIsUploadingImage(false));
    };

    const handleAvatarEditClick = () => {
        if (isUploadingImage) {
            return;
        }
        profileImageInputRef.current?.click();
    };


    const handleProfileImageChange = (event) => {
        const file = event.target.files?.[0];
        if (!file) {
            return;
        }

        const allowedTypes = ['image/jpeg', 'image/png', 'image/webp', 'image/jpg'];
        if (!allowedTypes.includes(file.type)) {
            showNotification('Error', 'Please select a JPG, JPEG, PNG, or WEBP image', 'danger');
            event.target.value = '';
            return;
        }

        const reader = new FileReader();
        reader.onloadend = () => {
            const fullDataUrl = reader.result;
            if (typeof fullDataUrl !== 'string') {
                showNotification('Error', 'Unable to read the selected image', 'danger');
                return;
            }
            // Open cropper modal with the image
            setCropperImageSrc(fullDataUrl);
            setIsCropperOpen(true);
            setCrop({ x: 0, y: 0 });
            setZoom(1);
        };
        reader.readAsDataURL(file);
        event.target.value = '';
    };

    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
    }, []);

    const handleCropSave = async () => {
        if (!croppedAreaPixels || !cropperImageSrc) {
            return;
        }

        try {
            const croppedBase64 = await getCroppedImg(cropperImageSrc, croppedAreaPixels);
            setIsCropperOpen(false);
            // Store cropped image locally for immediate display
            setProfileImageSrc(croppedBase64);
            setProfileImage(croppedBase64);
            // Only upload to server if user is logged in (has userID)
            const userID = localStorage.getItem('userID');
            if (userID) {
                updateProfileImage(croppedBase64);
            } else {
                // During signup, just store locally - will be uploaded after successful signup
                showNotification('Success', 'Image selected successfully', 'success');
            }
        } catch (error) {
            console.error('Error cropping image:', error);
            showNotification('Error', 'Failed to crop image', 'danger');
        }
    };

    const handleCropCancel = () => {
        setIsCropperOpen(false);
        setCropperImageSrc('');
        setCrop({ x: 0, y: 0 });
        setZoom(1);
        setCroppedAreaPixels(null);
    };

    // Handle input changes for form data
    const handleInputChange = (field, value) => {
        switch (field) {
            case 'country':
                setCountryName(value);
                break;
            case 'state':
                setStateName(value);
                break;
            case 'city':
                setCityName(value);
                break;
            default:
                break;
        }
    };





    // Calculate current profile image - will update when state changes
    const currentProfileImage = profileImage || profileImageSrc || defaultProfileAvatar;

    const normalizeList = (payload) => {
        if (Array.isArray(payload)) {
            return payload;
        }
        if (payload && typeof payload === 'object') {
            return Object.values(payload);
        }
        return [];
    };

    function fetchCountryAPI() {
        console.log('Fetching countries...');
        fetch(baseURL.URL + '/address/country', { method: 'POST' })
            .then((response) => response.json())
            .then((responseJson) => {
                console.log("Countries loaded:", responseJson.response?.countries);
                setCountryNameArray(responseJson.response?.countries || []);
            })
            .catch((error) => {
                console.error('Error fetching countries:', error);
            });
    }

    function fetchStateAPI(cCode) {
        console.log("Fetching states for country code:", cCode);
        if (cCode) {
            let formdata = new FormData();
            formdata.append("country_code", cCode);
            fetch(baseURL.URL + '/address/state', { method: 'POST', body: formdata })
                .then((response) => response.json())
                .then((responseJson) => {
                    console.log("States API Response:", responseJson);
                    const statesPayload = responseJson.response?.states ?? responseJson.response?.regions ?? responseJson.response;
                    const normalizedStates = normalizeList(statesPayload);
                    console.log("Normalized states array:", normalizedStates);
                    setStateNameArray(normalizedStates);
                })
                .catch((error) => {
                    console.error('Error fetching states:', error);
                    setStateNameArray([]);
                });
        } else {
            setStateNameArray([]);
        }
    }

    function fetchCityAPI(sCode) {
        console.log("Fetching cities for state code:", sCode, "country code:", countryCode);
        if (sCode && countryCode) {
            let formdata = new FormData();
            formdata.append("country_code", countryCode);
            formdata.append("state_id", sCode);
            fetch(baseURL.URL + '/address/city', { method: 'POST', body: formdata })
                .then((response) => response.json())
                .then((responseJson) => {
                    console.log("Cities API Response:", responseJson);
                    const citiesPayload = responseJson.response?.cities ?? responseJson.response;
                    const normalizedCities = normalizeList(citiesPayload);
                    console.log("Normalized cities array:", normalizedCities);
                    setCityNameArray(normalizedCities);
                })
                .catch((error) => {
                    console.error('Error fetching cities:', error);
                    setCityNameArray([]);
                });
        } else {
            setCityNameArray([]);
        }
    }



    return (
        <>
            <ReactNotifications />
            <section className="login-section signup-section relative min-h-screen">
                <div id="canvas_container" ref={canvasContainerRef} />

                <div className="login-sign-in-overlay signup-sign-in-overlay">
                    <SignUpCard
                        logoSrc={logo}
                        onSubmit={signupApi}
                        isSubmitting={isSubmitting}
                        firstName={firstName}
                        onFirstNameChange={setFirstName}
                        lastName={lastName}
                        onLastNameChange={setLastName}
                        email={email}
                        onEmailChange={setEmail}
                        password={password}
                        onPasswordChange={setPassword}
                        confirmPassword={confirmPassword}
                        onConfirmPasswordChange={setConfirmPassword}
                        phone={phone}
                        onPhoneChange={setPhone}
                        countryCode={countryCode}
                        onCountryChange={handleCountryChange}
                        countryNameArray={countryNameArray}
                        stateCode={stateCode}
                        onStateChange={handleStateChange}
                        stateNameArray={stateNameArray}
                        cityCode={cityCode}
                        onCityChange={handleCityChange}
                        cityNameArray={cityNameArray}
                        currentProfileImage={currentProfileImage}
                        onProfileUploadClick={handleAvatarEditClick}
                        profileImageInputRef={profileImageInputRef}
                        onProfileImageChange={handleProfileImageChange}
                        isUploadingImage={isUploadingImage}
                        loginTo="/"
                    />
                </div>
            </section>

            {/* Image Cropper Modal */}
            {isCropperOpen && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    zIndex: 10000,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '20px'
                }}>
                    <div style={{
                        backgroundColor: 'white',
                        borderRadius: '12px',
                        padding: '20px',
                        maxWidth: '90vw',
                        maxHeight: '90vh',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '20px',
                        width: '100%',
                        maxWidth: '600px'
                    }}>
                        <h3 style={{ margin: 0, fontSize: '20px', fontWeight: '600' }}>Crop Image</h3>
                        <div style={{
                            position: 'relative',
                            width: '100%',
                            height: '400px',
                            backgroundColor: '#f5f5f5',
                            borderRadius: '8px',
                            overflow: 'hidden'
                        }}>
                            <Cropper
                                image={cropperImageSrc}
                                crop={crop}
                                zoom={zoom}
                                aspect={1}
                                onCropChange={setCrop}
                                onZoomChange={setZoom}
                                onCropComplete={onCropComplete}
                            />
                        </div>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '15px'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px'
                            }}>
                                <label style={{ fontSize: '14px', fontWeight: '500', minWidth: '60px' }}>Zoom:</label>
                                <input
                                    type="range"
                                    value={zoom}
                                    min={1}
                                    max={3}
                                    step={0.1}
                                    onChange={(e) => setZoom(parseFloat(e.target.value))}
                                    style={{
                                        flex: 1,
                                        height: '6px',
                                        borderRadius: '3px',
                                        background: '#ddd',
                                        outline: 'none'
                                    }}
                                />
                                <span style={{ fontSize: '14px', minWidth: '40px', textAlign: 'right' }}>
                                    {zoom.toFixed(1)}x
                                </span>
                            </div>
                            <div style={{
                                display: 'flex',
                                gap: '10px',
                                justifyContent: 'flex-end'
                            }}>
                                <button
                                    onClick={handleCropCancel}
                                    style={{
                                        padding: '10px 20px',
                                        backgroundColor: '#f5f5f5',
                                        border: '1px solid #ddd',
                                        borderRadius: '6px',
                                        cursor: 'pointer',
                                        fontSize: '16px',
                                        fontWeight: '500'
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleCropSave}
                                    style={{
                                        padding: '10px 20px',
                                        backgroundColor: '#1C4CAF',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '6px',
                                        cursor: 'pointer',
                                        fontSize: '16px',
                                        fontWeight: '500'
                                    }}
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Upload Loader */}
            {isUploadingImage && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    zIndex: 9999,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <div style={{
                        backgroundColor: 'white',
                        padding: '30px',
                        borderRadius: '12px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: '20px'
                    }}>
                        <div style={{
                            width: '50px',
                            height: '50px',
                            border: '4px solid #f3f3f3',
                            borderTop: '4px solid #1C4CAF',
                            borderRadius: '50%',
                            animation: 'spin 1s linear infinite'
                        }} />
                        <p style={{ margin: 0, fontSize: '16px', fontWeight: '500' }}>Uploading image...</p>
                    </div>
                </div>
            )}
        </>
    );
}